export function isSemver(version) {
  return /^\d+\.\d+\.\d+$/.test(String(version).trim());
}

/**
 * @returns {-1|0|1}
 */
export function compareSemver(a, b) {
  const aParts = String(a).trim().split('.').map((n) => parseInt(n, 10));
  const bParts = String(b).trim().split('.').map((n) => parseInt(n, 10));

  for (let i = 0; i < 3; i++) {
    const av = Number.isFinite(aParts[i]) ? aParts[i] : 0;
    const bv = Number.isFinite(bParts[i]) ? bParts[i] : 0;
    if (av < bv) return -1;
    if (av > bv) return 1;
  }

  return 0;
}
